import { useDispatch } from 'react-redux';

import { AppDispatch } from '@store/store.interface';

export default () => useDispatch<AppDispatch>();
